import styled from "styled-components";

export const Wrapper = styled.div`
    text-align: center;
    padding: 40px 20px;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.crimson};
`;
